import { Pipe, PipeTransform } from '@angular/core';
import {PredesignSizeInfo} from "@nx-averycom/shared/avry-models";

@Pipe({
  name: 'getSizeInfo',
})
export class GetSizeInfoPipe implements PipeTransform {
  transform(value: PredesignSizeInfo[], userSelection: string): PredesignSizeInfo | null {
    let result: PredesignSizeInfo | null = null;

    if (value && userSelection) {
      result = value.find((v) => v.key === userSelection) || null;
    }

    return result;
  }
}
